import CanvasControls from './CanvasControls';

export default CanvasControls;
